<template>
  <div id="evaluate-question-risk">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <div class="title">风险评测<span></span></div>
      </div>
      <div class="section section2">
        <div class="title">答题进度</div>
        <div class="progress">
          <div class="value" id="questionProgress"> > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > > >
            > > > > > > > > > > > > > > </div>
          <div class="number" id="questionProgressNumber"></div>
        </div>
      </div>
      <div class="section section3">
        <div class="content">
          <div v-for="(value,index) in questionData" :key="index">
            <!--  1 单选题   -->
            <div class="que-box que-box-select" v-show="value.que_type===1">
              <div class="que-index">{{ index+1 +')  '}}</div>
              <div class="que-title">{{value.que_content}}<span>(单选)</span></div>
              <div class="box-input" v-for="(item,ind) in value.riskevalAnswerList" :key="ind">
                <div class="que-value" @click="itemSelClick(value.riskevalAnswerList,item)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
              </div>
            </div>
            <!-- 5 输入框   -->
            <!--            <div class="que-box que-box-input" v-show="value.que_type===5">-->
            <!--              <div class="que-title">{{ index+1 +' ) '+ value.que_content}}<span>(输入框)</span></div>-->
            <!--              <input v-model="value.que_value"/>-->
            <!--            </div>-->
            <div class="que-box que-box-select" v-show="value.que_type===2">
              <div class="que-index">{{ index+1 +')  '}}</div>
              <div class="que-title">{{value.que_content}}<span>(多选)</span></div>
              <div class="box-input" v-for="(item,ind) in value.riskevalAnswerList" :key="ind">
                <div class="que-value" @click="itemMselClick2(value.riskevalAnswerList,item,ind)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
              </div>
            </div>
            <!-- 6 多选输入框 - 选最后一个 全取消  -->
            <div class="que-box que-box-select" v-show="value.que_type===6">
              <div class="que-index">{{ index+1 +')  '}}</div>
              <div class="que-title">{{value.que_content}}<span>(多选加输入框)</span></div>
              <div class="box-input" v-for="(item,ind) in value.riskevalAnswerList" :key="ind">
                <div class="que-value" @click="itemMselInputClick(value.riskevalAnswerList,item,ind)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
                <input v-model="item.que_value" v-show="item.isSel && ind+1 !== value.riskevalAnswerList.length" />
              </div>
            </div>
            <!--  2 多选题  3 问卷提  4 对象属性题   -->
            <div class="que-box que-box-select" v-show="value.que_type===3 || value.que_type===4">
              <div class="que-index">{{ index+1 +')  '}}</div>
              <div class="que-title">{{value.que_content}}<span>(多选)</span></div>
              <div class="box-input" v-for="(item,ind) in value.riskevalAnswerList" :key="ind">
                <div class="que-value" @click="itemMselClick(value.riskevalAnswerList,item,ind)">
                  <div class="image" :class="{'defaultImage': !item.isSel,'selImage': item.isSel}"></div>
                  <div class="value">{{item.answer_content}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="position: relative;background-color: #ffffff;height: 60px;left: 0px;margin-top: -10px;margin-bottom: 10px">
          <img style="position: absolute;left:35px;top: 15px;height: 20px;width: 20px;" src="../assets/icon-warn.jpg" />
          <div
            style="position: absolute;left:60px;top: 15px;height: 20px;line-height: 20px;color: #c41335;font-size: 14px;">
            【请确保以上答题内容真实有效】</div>
        </div>
      </div>
    </div>
    <bottomButton title="提交" :state="1" @click="bottomClick"></bottomButton>
  </div>
</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      questionData: [],
      resultId: ''
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({ path: 'home' })
      // this.$router.replace('home')
    },
    questionProgress: function () {
      // 答题 进度
      var _this = this
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log(userinfo)
      this.utils.GETHeader(this.accountUrl + '/riskeval/getProgress', { 'phone': userinfo.tails.userinfo[0].phone }, function (response) {
        let data = response.data
        if (JSON.stringify(data) !== '{}') { // 评测进度
          // progress 0 初始化,提交了企业信息  1 完成二级答题 2 完成三级答题 3 完成评测
          let progressRate = data.progress_rate
          _this.resultId = data.result_id
          var width = progressRate * 0.01 * (document.body.clientWidth - 30)
          document.getElementById('questionProgress').style.width = width + 'px'
          document.getElementById('questionProgressNumber').innerText = data.progress_rate + '%'
        }
      })
    },
    itemSelClick: function (values, value) { // 单选
      for (let i = 0; i < values.length; i++) {
        let item = values[i]
        item.isSel = 0
        if (item.id === value.id) {
          value.isSel = 1
        }
      }
    },
    itemMselClick: function (values, value, index) { // 多选
      if (values.length === index + 1) {
        for (let i = 0; i < values.length; i++) {
          let item = values[i]
          item.isSel = 0
          if (item.id === value.id) {
            value.isSel = 1
          }
        }
      } else {
        var item = values[values.length - 1]
        if (item.isSel === 1) {
          item.isSel = 0
        }
        if (value.isSel === 0) {
          value.isSel = 1
        } else {
          value.isSel = 0
        }
      }
    },
    itemMselClick2: function (values, value, index) { // 多选
      var number = 0
      if (value.isSel === 0) {
        for (let i = 0; i < values.length; i++) {
          let item = values[i]
          if (item.isSel === 1) {
            number += 1
            if (number >= 4) { // 最多选 四个
              return
            }
          }
        }
      }
      if (value.isSel === 0) {
        value.isSel = 1
      } else {
        value.isSel = 0
      }
    },
    itemMselInputClick: function (values, value, index) { // 多选 输入框
      if (values.length === index + 1) {
        for (let i = 0; i < values.length; i++) {
          let item = values[i]
          item.isSel = 0
          if (item.id === value.id) {
            value.isSel = 1
          }
        }
      } else {
        var item = values[values.length - 1]
        if (item.isSel === 1) {
          item.isSel = 0
        }
        if (value.isSel === 0) {
          value.isSel = 1
        } else {
          value.isSel = 0
        }
      }
    },
    bottomClick: function (type) { // 下一步
      console.log('=======================下一步')
      // 1 单选 2 3 4 多选  5输入框 6多选加输入框
      // 判断 答案是否 填写 完整
      var userQuestionAnswerList = []
      for (var i = 0; i < this.questionData.length; i++) {
        var item = this.questionData[i]
        // 答案
        // 单选 多选题
        // if (item.que_type === 1 || item.que_type === 2 || item.que_type === 3 || item.que_type === 4 || item.que_type === 6) {
        // console.log('=======================单选题')
        var selIds = ''
        for (var j = 0; j < item.riskevalAnswerList.length; j++) {
          // console.log('选项循环=======')
          var selItem = item.riskevalAnswerList[j]
          if (selItem.isSel) {
            selIds += (selItem.id + ',')
          }
          if (j === item.riskevalAnswerList.length - 1) {
            if (selIds.length > 0) {
              if (selIds.indexOf(',') >= 0) {
                selIds = selIds.slice(0, selIds.length - 1)
              }
              var quevalueObj = {}
              if (item.que_type === 1) {
                quevalueObj = { 'question_id': item.id, 'answer_ids': selIds }
              } else {
                quevalueObj = { 'question_id': item.id, 'answer_ids': selIds }
              }
              userQuestionAnswerList.push(quevalueObj)
            } else {
              Toast('请完成答题')
              return
            }
          }
        }
        // }
        // if (item.que_type === 5) {
        //   console.log('=======================输入框' + item.que_value)
        //   if (item.que_value.length <= 0) {
        //     Toast('请完成答题3')
        //     return
        //   } else {
        //     var quevalueObj2 = {'answer': parseInt(item.que_value)}
        //     userQuestionAnswerList.push(quevalueObj2)
        //     item.userQuestionAnswerList = userQuestionAnswerList
        //   }
        // }
      }
      console.log(JSON.stringify(userQuestionAnswerList))
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      console.log(JSON.stringify(userQuestionAnswerList))
      // 提交 答题
      var _this = this
      this.utils.POSTHeaderQS(this.accountUrl + '/riskevalNew/commitQuestion', { 'phone': userinfo.tails.userinfo[0].phone }, false, userQuestionAnswerList, function (response) {
        // 评测 完成 获取 评测结果
        // if (response.code === 0) {
        _this.$router.push({ path: 'fxcp_result', query: { resultId: _this.resultId } })
        // }
      })
    },
    loadRiseData: function () {
      var _this = this
      this.utils.GET(this.accountUrl + '/riskeval/getQuestion', function (response) {
        var result = response.data
        for (let i = 0; i < result.length; i++) {
          // var que = result[i]
          // 单选题 选项题
          // if (que.que_type === 1 || que.que_type === 2 || que.que_type === 3 || que.que_type === 4 || que.que_type === 6) {
          for (let k = 0; k < result[i].riskevalAnswerList.length; k++) {
            var item = result[i].riskevalAnswerList[k]
            // 初始化 选择状态 选项 答案
            item.isSel = 0
            item.que_value = ''
          }
          // }
          // // 输入题
          // if (que.que_type === 5) {
          //   // 初始化 答案字段
          //   que.que_value = ''
          // }
        }
        _this.questionData = result
      })
    },
    binBack: function () {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    }
  },
  watch: {
    $router () {
    }
  },
  computed: {
  },
  components: {
    mainHeader,
    bottomButton
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({ path: 'home' })
      }
    })
    this.loadRiseData()
    this.binBack()
    setTimeout(function () {
      _this.questionProgress()
    }, 1000)
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
  }
}
</script>

<style scoped>
.mainHeader {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 500;
}
.wrapper {
  background-color: #f4f4f4;
  /*height: 100%;*/
  margin-top: 55px;
  padding-bottom: 65px;
}
.section {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.section .title {
  height: 50px;
  line-height: 50px;
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-left: 15px;
}
.section1 {
  height: 50px;
}
.section2 {
  height: 75px;
}
.section2 .title {
  text-align: center;
}
.section2 .progress {
  position: absolute;
  left: 15px;
  right: 15px;
  top: 50px;
  height: 8px;
  background-color: #eeeeee;
  border-radius: 4px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.19);
  overflow: hidden;
}
.section2 .progress .value {
  position: absolute;
  /*width: 100%;*/
  width: 0%;
  top: -2px;
  height: 10px;
  line-height: 10px;
  background-color: #c41335;
  color: #ffffff;
}
.section2 .progress .number {
  position: absolute;
  right: 5px;
  top: 0px;
  height: 8px;
  line-height: 8px;
  color: #808080;
  font-size: 11px;
}
.section3 {
  /*position: relative;*/
  min-height: 300px;
  margin-bottom: 0px;
}
.section3 .content {
  /*margin: 0 15px;*/
}
.section3 .content .que-box {
  position: relative;
  width: 100%;
  min-height: 100px;
  border-bottom: solid 10px #f4f4f4;
  box-sizing: border-box;
}
.section3 .content .que-box .que-index {
  position: relative;
  top: 15px;
  margin-left: 15px;
  margin-right: 15px;
  line-height: 25px;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
.section3 .content .que-box .que-title {
  position: relative;
  top: -10px;
  /*margin-left: 15px;*/
  margin-left: 40px;
  margin-right: 15px;
  line-height: 25px;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
}
.section3 .content .que-box .que-title span {
  top: 15px;
  margin-left: 5px;
  margin-right: 15px;
  line-height: 25px;
  color: #808080;
  font-size: 13px;
  font-weight: normal;
}
/* 输入 */
.section3 .content .que-box-input input {
  position: relative;
  margin-bottom: 25px;
  margin-top: 30px;
  margin-left: 35px;
  width: 70%;
  height: 35px;
  border: solid #eeeeee 1px;
  box-sizing: border-box;
  padding: 0 10px;
  /*background: yellow;*/
  border-radius: 0px;
}
/* 单选 多选 */
.section3 .content .que-box-select .box-input {
  position: relative;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 35px;
  line-height: 30px;
  /*background: yellow;*/
}
.section3 .content .que-box-select .box-input:nth-child(2) {
  margin-top: 30px;
  /*background-color: #FFEECC;*/
}
.section3 .content .que-box-select .box-input:last-of-type {
  margin-bottom: 20px;
}
.section3 .content .que-box .box-input .que-value {
  position: relative;
  color: #000000;
  font-size: 14px;
}
.section3 .content .que-box .box-input .image {
  position: relative;
  top: 0px;
  margin-left: 0px;
  height: 20px;
  width: 20px;
}
.section3 .content .que-box .box-input .value {
  position: relative;
  top: -20px;
  /*margin-left: 15px;*/
  margin-left: 30px;
  margin-right: 15px;
  line-height: 20px;
  color: #000000;
}
.defaultImage {
  background-image: url("../assets/radio_n.png");
  background-size: cover;
  background-position: center center;
}
.selImage {
  background-image: url("../assets/radio_s.png");
  background-size: cover;
  background-position: center center;
}
/* 多选 输入 */
.section3 .content .que-box-select .box-input input {
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 35px;
  width: 70%;
  height: 35px;
  border: solid #eeeeee 1px;
  box-sizing: border-box;
  padding: 0 10px;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/evaluate-question-risk.vue